/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Components */
import ConversionFlow from "./components/ConversionFlow";
import ConversionFlowInPage from "./components/ConversionFlowInPage";

/* utilities */
import { parseDataToProps } from '~/utilities';

const conversionFlowNodes = Array.from(document.querySelectorAll('.conversion-flow'));
[...conversionFlowNodes].forEach((node) => render(<ConversionFlow {...parseDataToProps(node.dataset)} />, node));

const conversionFlowInPageNodes = Array.from(document.querySelectorAll('.conversion-flow-in-page'));
[...conversionFlowInPageNodes].forEach((node) => render(<ConversionFlowInPage {...parseDataToProps(node.dataset)} />, node));
